import { withSubComponents } from "capitalrx-components-2.0";
import { RefComponent, TextboxProps } from "capitalrx-components-2.0/lib/forms";
import { Placeholder } from "capitalrx-components-2.0/lib/forms/Textbox/Placeholder";
import { forwardRef } from "react";
import { Field } from "./Field";
import { SharedTypeaheadTextboxProps } from "./Props";
import { DataId } from "capitalrx-components-2.0/lib/general";
import { Input } from "./Input";

export type TypeaheadTextboxProps<TRow extends object, TMetadata extends object> = TextboxProps
  & SharedTypeaheadTextboxProps<TRow, TMetadata>
  & {
    readonly onItemSelected?: (row: DataId) => void;
  }

export interface TypeaheadTextboxSubComponents {
  /**
   * A React Hook Form compatible Textbox Field component. For more information, see the documentation for
   * the <a href="https://react-hook-form.com/api">React Hook Form API</a>.
   */
  readonly Field: typeof Field;

  /**
   * A placeholder component for the Textbox which can be displayed while loading.
   */
  readonly Placeholder: typeof Placeholder;
}

export const TypeaheadTextbox = withSubComponents<
  RefComponent<HTMLInputElement, TypeaheadTextboxProps<any, any>>,
  TypeaheadTextboxSubComponents
>(
  {
    Field,
    Placeholder,
  },
  forwardRef<HTMLInputElement, TypeaheadTextboxProps<any, any>>(function TypeaheadTextbox(props, ref) {
    return <Input {...props} ref={ref} type="text" />;
  }),
);
